import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { userMiddleware, userReducer, userReducerPath } from "./user/api";
import { fileMiddleware, fileReducer, fileReducerPath } from "./file/api";
import {
  mastersMiddleware,
  mastersReducer,
  mastersReducerPath,
} from "./master";
import {
  productsMiddleware,
  productsReducer,
  productsReducerPath,
} from "./products";
import {
  advanceSearchMiddleware,
  advanceSearchReducer,
  advanceSearchReducerPath,
} from "./advanceSearch";

export const store = configureStore({
  reducer: {
    [userReducerPath]: userReducer,
    [fileReducerPath]: fileReducer,
    [mastersReducerPath]: mastersReducer,
    [productsReducerPath]: productsReducer,
    [advanceSearchReducerPath]: advanceSearchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userMiddleware)
      .concat(fileMiddleware)
      .concat(mastersMiddleware)
      .concat(productsMiddleware)
      .concat(advanceSearchMiddleware),
});

setupListeners(store.dispatch);
